import {snakeCase} from 'lodash-es';

export class ResourceHelper {
  /**
   * Wandelt ein Objekt in ein neues Objekt mit snake_case-Schlüsseln um.
   * Boolean-Werte werden in '1' bzw. '0' umgewandelt.
   * @param query Das Eingangsobjekt
   * @returns Neues Objekt mit konvertierten Schlüsseln und Werten
   */
  public static mapQuery(query: Record<string, any> | null | undefined): Record<string, any> {
    if(!query) {
      return {};
    }

    return Object.entries(query)
      .filter(([_, value]) => {
        if(Array.isArray(value)) {
          return value.length > 0;
        }
        return value !== null && value !== undefined;
      })
      .reduce((acc, [key, value]) => {
        acc[snakeCase(key)] = ResourceHelper.convertValue(value);
        return acc;
      }, {} as Record<string, any>);
  }

  /**
   * Konvertiert Werte: Boolean in '1'/'0', Datum in ISO-String, Arrays in CSV-String.
   * @param value Der zu konvertierende Wert
   * @returns Konvertierter Wert
   */
  private static convertValue(value: any): any {
    if(typeof value === 'boolean') {
      return value ? '1' : '0';
    }
    return value;
  }
}